import { _ as _objectSpread2, c as _objectWithoutProperties, r as resetFocus, n as noFocus, a as _defineProperty, v as variables, h as cssVarPrefixed, b as _slicedToArray, t as transition, s as shadows } from './transitions-0cec78fb.esm.js';
import _pick from 'ramda/src/pick';
import { iconSizes as iconSizes$1 } from '@hover/blueprint-theme/components';
import { assertUnreachable, fromEntries, entries, mapValues } from '@hover/utilities';
import _mergeDeepRight from 'ramda/src/mergeDeepRight';
import _values from 'ramda/src/values';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';
import _map from 'ramda/src/map';
import { _ as _toConsumableArray } from './toConsumableArray-339d57a9.esm.js';
import _mergeDeepWith from 'ramda/src/mergeDeepWith';
import { calc as calc$1, cssVar as cssVar$1, orient } from '@chakra-ui/theme-tools';
import { iconSizes, textSizes, motion, shadowHalo, buttonSizes, colorSchemeWithDefault, textSize, headingSize, spaceForBorderWidth } from '@hover/blueprint-theme';
import { position, transitions, transparentize, math } from 'polished';
import '@hover/tokens-typography';
import { d as disabledSelector, h as hoverSelector, a as activeSelector } from './button-1b672cc0.esm.js';
import { cssVar, calc } from '@chakra-ui/react';
import { s as sizes$9 } from './sizes-77976ad9.esm.js';
import { s as space } from './space-a5a5bc2c.esm.js';
import { f as field, s as sizes$a, v as variants$1, p as paddingHorizontalMedium, a as paddingHorizontalSmall, b as paddingHorizontalTiny } from './menu-ee672939.esm.js';
import { s as sizes$b } from './text-298e325b.esm.js';
import { progressAnatomy } from '@chakra-ui/anatomy';
import { keyframes } from '@emotion/react';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var mergeSizes = /*#__PURE__*/_mergeDeepWith(function (left, right) {
  return [].concat(_toConsumableArray(Array.isArray(left) ? left : [left]), _toConsumableArray(Array.isArray(right) ? right : [right]));
});

/**
 * Merge a style object containing a set of discrete sizes to a single style
 * object that leverages responsive style props to apply each size to a
 * corresponding media query. The style object must include at least `small`,
 * `medium` and `large` sizes. The smallest and largest size (`tiny` and `huge`)
 * are optional and when omitted will simply be replaced by `small` and `large`
 * respectively in the resulting responsive object.
 *
 * @see https://chakra-ui.com/docs/styled-system/features/responsive-styles#the-array-syntax
 *
 * @param sizes object of sizes style objects with sizes as keys
 * @returns merged style object containing single size with array-style responsive values
 */
var mergeSizesToResponsive = function mergeSizesToResponsive(_ref) {
  var t = _ref.tiny,
    small = _ref.small,
    medium = _ref.medium,
    large = _ref.large,
    h = _ref.huge;
  var tiny = t !== null && t !== void 0 ? t : small;
  var huge = h !== null && h !== void 0 ? h : large;
  return [tiny,
  // base
  tiny,
  // width100
  tiny,
  // width200
  tiny,
  // mobile
  small,
  // width250
  small,
  // width300
  medium,
  // tablet
  large,
  // width350
  huge // desktop+
  ].reduce(mergeSizes);
};

/**
 * Apply a function to a styled-system responsive prop value
 *
 * @example
 * mapResponsive(value => `${value}px`, 100) // Simple value
 * // 100px
 *
 * mapResponsive(value => `${value}px`, [100, 200]) // Responsive array
 * // ['100px', '200px']
 *
 * mapResponsive(value => `${value}px`, { mobile: 100, desktop: 200 }) // Responsive object
 * // { mobile: '100px', desktop: '200px' }
 *
 * @param fn function to apply to responsive values
 * @param prop responsive prop to map over
 * @param fallback fallback value for handling `null` values in the case of `['foo', 'bar', null]`
 */
var mapResponsive = function mapResponsive(fn, prop, fallback) {
  if (!prop) return prop;
  if (Array.isArray(prop)) return _map(function (p) {
    return p ? fn(p) : fallback !== null && fallback !== void 0 ? fallback : null;
  }, prop);
  if (_typeof(prop) !== 'object') return fn(prop);
  return _mapObjIndexed(fn, prop);
};

/**
 * Apply a reducer to a styled-system responsive prop value
 *
 * @example
 * reduceResponsive((a, v) => a + v, 0, 100) // Simple value
 * // 100
 *
 * reduceResponsive((a, v) => a + v, 0, [100, 200]) // Responsive array
 * // 300
 *
 * reduceResponsive((a, v) => a + v, 0, { mobile: 100, desktop: 200 }) // Responsive object
 * // 300
 *
 * @param fn function to apply to responsive values
 * @param initial initial value for reduce operation
 * @param prop responsive prop to map over
 */
var reduceResponsive = function reduceResponsive(fn, initial, prop) {
  if (Array.isArray(prop)) return prop.reduce(fn, initial);
  if (_typeof(prop) === 'object') {
    // Not sure how to narrow out `T` from `ResponsiveValue<T>`
    return _values(prop).reduce(fn, initial);
  }
  return [prop].reduce(fn, initial);
};

/**
 * This is a custom component as Chakra does support theming the built-in
 * `Icon` component. This component theme is applied to our custom icon
 * implementations such as `AwesomeIcon`
 *
 * @see `src/components/AwesomeIcon`
 */
var Icon = {
  baseStyle: {
    display: 'block'
  },
  defaultProps: {
    size: 'small'
  },
  sizes: iconSizes,
  variants: {}
};

var _excluded$5 = ["theme"];
var pickSize = /*#__PURE__*/_pick(['width', 'height', 'strokeWidth']);
var backgroundFor = function backgroundFor(status) {
  switch (status) {
    case 'success':
      return 'success.100';
    case 'warning':
      return 'warning.100';
    case 'error':
      return 'danger.100';
    case 'loading':
      return 'neutral.100';
    case 'info':
    case undefined:
      return 'primary.100';
    default:
      return assertUnreachable(status);
  }
};
var iconColorFor = function iconColorFor(status) {
  switch (status) {
    case 'success':
      return 'success.base';
    case 'warning':
      return 'warning.base';
    case 'error':
      return 'danger.base';
    case 'loading':
      return 'neutral.500';
    case 'info':
    case undefined:
      return 'primary.base';
    default:
      return assertUnreachable(status);
  }
};
var subtle = function subtle(_ref) {
  var status = _ref.status;
  return {
    container: {
      background: backgroundFor(status)
    },
    icon: {
      color: iconColorFor(status)
    }
  };
};
var Alert = {
  defaultProps: {
    variant: 'subtle',
    size: 'default'
  },
  parts: ['confirm', 'confirmButton', 'container', 'description', 'icon', 'title', 'titleIcon'],
  baseStyle: {
    container: {
      alignItems: 'center',
      borderRadius: 300,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row'
    },
    description: {
      color: 'neutral.text',
      fontFamily: 'body',
      fontWeight: 'body'
    },
    icon: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0
    },
    titleIcon: {
      marginTop: 0,
      marginBottom: 0
    },
    title: {
      color: 'neutral.text',
      fontFamily: 'heading',
      fontWeight: 'heading'
    }
  },
  sizes: {
    small: {
      confirm: {
        gap: 200
      },
      container: {
        paddingX: '300',
        paddingY: '200'
      },
      icon: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/pickSize(iconSizes$1.small)), {}, {
        marginRight: 300
      }),
      titleIcon: /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/pickSize(iconSizes$1.large)),
      description: {
        textStyle: 'body400'
      },
      title: {
        textStyle: 'heading200WithMargin'
      }
    },
    "default": function _default(props) {
      return {
        confirm: {
          gap: 300
        },
        confirmButton: {
          height: props.title ? 350 : 300
        },
        container: {
          paddingX: '400',
          paddingY: '300'
        },
        icon: _objectSpread2(_objectSpread2({}, pickSize(iconSizes$1.medium)), {}, {
          marginRight: 300
        }),
        titleIcon: _objectSpread2({}, pickSize(iconSizes$1.huge)),
        description: {
          textStyle: 'body500'
        },
        title: {
          textStyle: 'heading300WithMargin'
        }
      };
    }
  },
  variants: {
    subtle: subtle,
    toast: function toast(props) {
      var _subtle = subtle(props),
        icon = _subtle.icon,
        container = _subtle.container;
      return {
        icon: icon,
        container: _objectSpread2(_objectSpread2({}, container), {}, {
          borderRadius: 400,
          shadow: 'distance400'
        })
      };
    },
    quote: function quote(_ref2) {
      var colors = _ref2.theme.colors,
        props = _objectWithoutProperties(_ref2, _excluded$5);
      return {
        container: colors.softColorFor(props.colorScheme),
        description: {
          marginLeft: 200
        }
      };
    }
  }
};

var sizes$8 = {
  full: {
    header: {
      textStyle: 'heading600',
      marginBottom: '300'
    },
    dialog: {
      boxSizing: 'border-box',
      paddingX: '500',
      paddingTop: '400',
      paddingBottom: '500',
      borderRadius: '0',
      width: '100vw'
    },
    closeButton: {
      top: '300',
      right: '300'
    }
  },
  small: {
    header: {
      textStyle: 'heading600',
      marginBottom: '300'
    },
    dialog: {
      boxSizing: 'content-box',
      paddingX: '500',
      paddingTop: '400',
      paddingBottom: '500'
    },
    closeButton: {
      top: '300',
      right: '300'
    }
  },
  medium: {
    header: {
      textStyle: 'heading650',
      marginBottom: '300'
    },
    dialog: {
      boxSizing: 'content-box',
      paddingX: '600',
      paddingTop: '500',
      paddingBottom: '600'
    },
    closeButton: {
      top: '400',
      right: '400'
    }
  },
  large: {
    header: {
      textStyle: 'heading650',
      marginBottom: '300'
    },
    dialog: {
      boxSizing: 'content-box',
      paddingX: '600',
      paddingTop: '500',
      paddingBottom: '600'
    },
    closeButton: {
      top: '400',
      right: '400'
    }
  }
};
var baseStyle = {
  dialog: {
    boxSizing: 'content-box',
    background: 'neutral.0',
    boxShadow: 'distance400'
  },
  header: {
    padding: 0,
    color: 'neutral.text',
    fontFamily: 'heading',
    fontWeight: 'heading'
  },
  body: {
    color: 'neutral.text',
    padding: 0,
    fontFamily: 'body',
    fontWeight: 'body',
    overflow: 'auto',
    textStyle: 'body500'
  },
  footer: {
    padding: 0,
    marginTop: '600'
  },
  overlay: {
    bg: 'overlayDark',
    zIndex: 'overlay'
  },
  closeButton: {
    position: 'absolute'
  }
};
var baseStyleModal = function baseStyleModal(_ref) {
  var isCentered = _ref.isCentered,
    scrollBehavior = _ref.scrollBehavior;
  return _mergeDeepRight(baseStyle, {
    dialog: {
      borderRadius: '300',
      color: 'inherit',
      my: isCentered ? 'auto' : '900',
      mx: isCentered ? 'auto' : undefined,
      zIndex: 'modal',
      maxH: scrollBehavior === 'inside' ? 'calc(100% - 7.5rem)' : undefined
    },
    dialogContainer: {
      display: 'flex',
      zIndex: 'modal',
      justifyContent: 'center',
      alignItems: isCentered ? 'center' : 'flex-start',
      overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto',
      overscrollBehaviorY: 'none'
    }
  });
};

var modalSizes = /*#__PURE__*/_mergeDeepRight(sizes$8, {
  full: {
    dialog: {
      maxW: '100vw',
      minH: '$100vh',
      my: '0',
      width: '100%'
    }
  },
  small: {
    dialog: {
      borderRadius: '300',
      width: '750'
    }
  },
  medium: {
    dialog: {
      borderRadius: '300',
      width: '800'
    }
  },
  large: {
    dialog: {
      borderRadius: '300',
      width: '850'
    }
  }
});
var responsive = /*#__PURE__*/mergeSizesToResponsive( /*#__PURE__*/_objectSpread2({
  tiny: sizes$8.full
}, modalSizes));
var sizes$7 = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, modalSizes), {}, {
  "default": responsive,
  auto: /*#__PURE__*/_mergeDeepRight(responsive, {
    dialog: {
      width: {
        base: '100%',
        width250: 'auto'
      }
    }
  })
});
var Modal = {
  defaultProps: {
    size: 'default'
  },
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: baseStyleModal,
  sizes: sizes$7,
  variants: {}
};

var AlertDialog = {
  defaultProps: {
    size: 'default'
  },
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: baseStyle,
  sizes: sizes$7,
  variants: {}
};

var lineHeight = textSizes[400].lineHeight;
var fontSize = textSizes[300].fontSize;
var Badge = {
  defaultProps: {
    colorScheme: 'neutral',
    variant: 'solid'
  },
  baseStyle: {
    lineHeight: lineHeight,
    fontSize: fontSize,
    borderRadius: 300,
    boxSizing: 'border-box',
    fontFamily: 'body',
    fontWeight: 'bodySemiBold',
    overflow: 'hidden',
    paddingX: 200,
    paddingY: 50,
    textTransform: 'uppercase'
  },
  sizes: {},
  variants: {
    solid: function solid(_ref) {
      var colorScheme = _ref.colorScheme,
        colors = _ref.theme.colors;
      return colors.colorFor(colorScheme);
    },
    brand: function brand(_ref2) {
      var colorScheme = _ref2.colorScheme,
        colors = _ref2.theme.colors;
      return _objectSpread2({
        borderRadius: 500,
        fontSize: '50',
        lineHeight: '50',
        fontWeight: 'bold',
        paddingX: 400,
        paddingY: 200
      }, colors.softColorFor(colorScheme));
    }
  }
};

var Button$1 = {
  parts: ['button', 'content'],
  baseStyle: function baseStyle(_ref) {
    var colors = _ref.theme.colors;
    return {
      button: _objectSpread2(_objectSpread2(_objectSpread2({
        borderRadius: 900,
        boxSizing: 'border-box',
        fontFamily: 'body',
        fontWeight: 'bold',
        paddingY: 0,
        position: 'relative',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }, transitions(['background', 'border', 'color', 'text-decoration'], motion.easings[250])), {}, {
        // Pseudo-element for focus halo
        _after: _objectSpread2(_objectSpread2(_objectSpread2({
          borderRadius: 900
        }, position('absolute', 0)), transitions(['bottom', 'box-shadow', 'left', 'right', 'top'], motion.easings[250])), {}, {
          shadow: 'invisibleNeutral',
          content: '""'
        })
      }, noFocus), resetFocus({
        _after: _objectSpread2({
          shadow: "0 0 0 3px ".concat(colors.alpha(0, 'primary.300'))
        }, position('absolute', '-6px'))
      }, {
        _after: _objectSpread2({
          shadow: 'invisibleNeutral'
        }, position('absolute', 0))
      })),
      content: {},
      decoration: {
        fill: 'none',
        stroke: 'currentColor'
      }
    };
  },
  sizes: {
    small: {
      button: {
        lineHeight: 50,
        fontSize: 100,
        height: 300
      },
      content: {
        paddingX: 600
      }
    },
    medium: {
      button: {
        lineHeight: 100,
        fontSize: 200,
        height: 400
      },
      content: {
        paddingX: 600
      }
    },
    large: {
      button: {
        lineHeight: 200,
        fontSize: 300,
        height: 500
      },
      content: {
        paddingX: 800
      }
    }
  },
  variants: {
    solid: function solid(_ref2) {
      var colorScheme = _ref2.colorScheme,
        colors = _ref2.theme.colors;
      var _colors$getStateColor = colors.getStateColors(colorScheme),
        active = _colors$getStateColor.active,
        idle = _colors$getStateColor.idle,
        hover = _colors$getStateColor.hover;
      return {
        button: {
          background: idle,
          color: 'neutral.0',
          _hover: {
            background: hover
          },
          _active: {
            bacground: active
          }
        }
      };
    },
    inverted: function inverted(_ref3) {
      var colorScheme = _ref3.colorScheme,
        colors = _ref3.theme.colors;
      var _colors$getStateColor2 = colors.getStateColors(colorScheme),
        color = _colors$getStateColor2.idle;
      return {
        button: {
          background: 'transparent',
          borderColor: 'neutral.0',
          borderStyle: 'solid',
          borderWidth: 500,
          position: 'relative',
          color: 'neutral.0',
          _hover: {
            background: 'neutral.0',
            color: color
          }
        }
      };
    },
    outline: function outline(_ref4) {
      var colorScheme = _ref4.colorScheme,
        colors = _ref4.theme.colors;
      var _colors$getStateColor3 = colors.getStateColors(colorScheme),
        idle = _colors$getStateColor3.idle,
        hover = _colors$getStateColor3.hover,
        active = _colors$getStateColor3.active,
        hoverBackground = _colors$getStateColor3.hoverBackground,
        activeBackground = _colors$getStateColor3.activeBackground;
      return {
        button: {
          background: 'transparent',
          borderColor: idle,
          borderStyle: 'solid',
          borderWidth: 500,
          position: 'relative',
          color: idle,
          _hover: {
            background: hoverBackground,
            borderColor: hover,
            color: hover
          },
          _active: {
            background: activeBackground,
            borderColor: active,
            color: active
          }
        }
      };
    },
    minimal: function minimal(_ref5) {
      var colorScheme = _ref5.colorScheme,
        colors = _ref5.theme.colors;
      var _ref6 = colorScheme === 'neutral' ? {
          idle: 'neutral.0',
          hover: 'primary.200',
          active: 'primary.300'
        } : colors.getStateColors(colorScheme),
        idle = _ref6.idle,
        hover = _ref6.hover,
        active = _ref6.active;
      return {
        button: {
          background: 'transparent',
          borderColor: 'transparent',
          borderStyle: 'solid',
          borderWidth: 500,
          color: idle,
          fontSize: 300,
          fontWeight: 'bodySemiBold',
          position: 'relative',
          textTransform: 'none',
          textDecoration: 'underline',
          textDecorationThickness: '1px',
          textDecorationColor: 'transparent',
          _hover: {
            textDecorationColor: 'currentColor',
            color: hover
          },
          _active: {
            textDecorationColor: 'currentColor',
            color: active
          }
        }
      };
    }
  },
  defaultProps: {
    size: 'medium',
    variant: 'solid',
    colorScheme: 'primary'
  }
};

/**
 * Common styles for inline links
 *
 * @param props component props
 * @param interactionSelector CSS selector to use to determine if component
 * should appear interative. If `false` is passed the element will always
 * appear interactive.
 */
var link = function link(_ref) {
  var colorScheme = _ref.colorScheme,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    isNext = _ref$theme.components.isNext;
  var interactionSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var neutral = isNext ? {
    idle: 'neutral.900',
    hover: 'neutral.900',
    active: 'neutral.800'
  } : {
    idle: 'neutral.0',
    hover: 'primary.200',
    active: 'primary.300'
  };
  var _ref2 = colorScheme === 'neutral' ? neutral : colors.getStateColors(colorScheme),
    idle = _ref2.idle,
    hover = _ref2.hover,
    active = _ref2.active;
  var interaction = interactionSelector ? _defineProperty(_defineProperty({}, "&:not(".concat(interactionSelector, ")"), {
    color: 'neutral.disabled',
    cursor: 'default'
  }), "_hover", _defineProperty({}, "&".concat(interactionSelector), {
    color: hover
  })) : {
    _hover: {
      color: hover
    }
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    color: idle,
    display: 'inline-flex',
    fontFamily: 'body',
    fontWeight: 'bodySemiBold',
    padding: 0,
    position: 'relative',
    transition: "\n        text-decoration-color ".concat(motion.easings[150], ",\n        color ").concat(motion.easings[250], "\n      ")
  }, interaction), {}, {
    _active: {
      color: active
    },
    _before: _objectSpread2(_objectSpread2({
      content: '""',
      opacity: 0
    }, transitions(['opacity'], motion.easings[150])), isNext ? _objectSpread2({
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'neutral.900',
      outlineOffset: '2px'
    }, position('absolute', 0, -1, 0, -1)) : _objectSpread2({
      borderRadius: 300,
      shadow: 'ringPrimary'
    }, position('absolute', 0, -1, 0, -1)))
  }, resetFocus({
    _before: {
      opacity: 1
    }
  }, {
    _before: {
      opacity: 0
    }
  })), {}, {
    _focus: {
      shadow: 'none'
    },
    _focusVisible: {
      shadow: 'none'
    },
    _hover: isNext ? {
      _focusVisible: {
        textDecorationColor: 'transparent !important',
        _before: {
          opacity: '1 !important'
        }
      }
    } : undefined
  });
};

/**
 * Underline styles for inline link
 *
 * @param interactionSelector CSS selector to use to determine if component
 * should appear interative. If `false` is passed the element will always
 * appear interactive.
 */
var underline = function underline() {
  var interactionSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var interaction = interactionSelector ? {
    _hover: _defineProperty(_defineProperty({}, "&".concat(interactionSelector), {
      textDecorationColor: 'currentColor'
    }), "&:not(".concat(interactionSelector, ")"), {
      textDecorationColor: 'transparent'
    })
  } : {
    _hover: {
      textDecorationColor: 'currentColor'
    }
  };
  return _objectSpread2({
    textDecoration: 'underline',
    textDecorationColor: 'transparent',
    _active: {
      textDecorationColor: 'transparent'
    }
  }, interaction);
};

var Breadcrumb = {
  defaultProps: {
    colorScheme: 'primary',
    variant: 'underline'
  },
  parts: ['item', 'link', 'container', 'separator'],
  baseStyle: function baseStyle(props) {
    return {
      container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        ol: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          margin: 0,
          padding: 0
        }
      },
      separator: {
        color: 'neutral.600'
      },
      item: {
        color: 'neutral.700',
        fontFamily: 'body',
        fontWeight: 'body'
      },
      link: _objectSpread2(_objectSpread2({}, link(props, ':not([aria-current=page])')), {}, {
        '&[aria-current=page]': {
          color: 'neutral.700',
          fontWeight: 'body'
        }
      })
    };
  },
  sizes: {},
  variants: {
    underline: function underline$1() {
      return {
        link: underline(':not([aria-current=page])')
      };
    }
  }
};

var getFocus = function getFocus(colorScheme, _ref) {
  var shadows = _ref.shadows;
  switch (colorScheme) {
    case 'primary':
      return {
        border: 'focus',
        boxShadow: shadows.haloPrimary
      };
    case 'success':
      return {
        border: 'focusSuccess',
        boxShadow: shadows.haloSuccess
      };
    case 'warning':
      return {
        border: 'focusWarning',
        boxShadow: shadows.haloWarning
      };
    case 'danger':
      return {
        border: 'focusDanger',
        boxShadow: shadows.haloDanger
      };
    case 'light':
      return {
        // TODO: do we need to add a system-wide light halo?
        boxShadow: shadowHalo(variables.color('lightAlpha.500').reference)
      };
    default:
      return {
        border: 'focusNeutral',
        boxShadow: shadows.haloNeutral
      };
  }
};

/**
 * Build styles for `solid` button fill variant
 *
 * @param props `Button` props
 * @returns
 */
var colorForSolid = function colorForSolid(_ref2) {
  var colorScheme = _ref2.colorScheme,
    theme = _ref2.theme;
  var colors = theme.colors;
  var _colors$getStateColor = colors.getStateColors(colorScheme, true),
    active = _colors$getStateColor.active,
    idle = _colors$getStateColor.idle,
    hover = _colors$getStateColor.hover;
  return _objectSpread2(_objectSpread2({
    color: colorScheme === 'light' ? colors.neutral[900] : colors.neutral['0'],
    border: 'none'
  }, resetFocus(getFocus(colorScheme, theme), {
    borderColor: 'transparent',
    shadow: 'invisibleNeutral'
  })), {}, _defineProperty({
    backgroundColor: idle,
    ':hover:not([disabled])': {
      backgroundColor: hover,
      borderColor: hover
    },
    ':active:not([disabled])': {
      backgroundColor: active,
      bordercolor: active
    }
  }, disabledSelector, {
    backgroundColor: 'neutral.disabled',
    borderColor: 'transparent',
    color: 'neutral.0'
  }));
};
var getInversePalette = function getInversePalette(colorScheme, _ref3) {
  var colors = _ref3.colors;
  var _colors$getStateColor2 = colors.getStateColors(colorScheme, true),
    activeColor = _colors$getStateColor2.active,
    hoverColor = _colors$getStateColor2.hover,
    color = _colors$getStateColor2.idle,
    activeBackground = _colors$getStateColor2.activeBackground,
    hoverBackground = _colors$getStateColor2.hoverBackground;
  return {
    activeColor: activeColor,
    hoverColor: hoverColor,
    color: color,
    hoverBackground: hoverBackground,
    activeBackground: activeBackground
  };
};

/**
 * Build styles for `outline` button fill variant
 *
 * @param props `Button` props
 * @returns
 */
var colorForOutline = function colorForOutline(_ref4) {
  var colorScheme = _ref4.colorScheme,
    theme = _ref4.theme;
  var _getInversePalette = getInversePalette(colorScheme, theme),
    color = _getInversePalette.color,
    hoverColor = _getInversePalette.hoverColor,
    hoverBackground = _getInversePalette.hoverBackground,
    activeColor = _getInversePalette.activeColor,
    activeBackground = _getInversePalette.activeBackground;
  var focus = getFocus(colorScheme, theme);
  var colors = theme.colors,
    shadows = theme.shadows;
  var idleShadow = "inset 0px 0px 0px 1px ".concat(colors.alpha(1, color));
  var hoverShadow = "inset 0px 0px 0px 1px ".concat(colors.alpha(0, hoverColor));
  var activeShadow = "inset 0px 0px 0px 1px ".concat(colors.alpha(0, activeColor));
  var idle = {
    color: color,
    backgroundColor: 'transparent',
    borderColor: 'currentcolor',
    boxShadow: [shadows.invisibleNeutral, idleShadow].join(',')
  };
  var hover = {
    color: hoverColor,
    backgroundColor: hoverBackground,
    boxShadow: [shadows.invisibleNeutral, hoverShadow].join(',')
  };
  var active = {
    color: activeColor,
    backgroundColor: activeBackground,
    boxShadow: [shadows.invisibleNeutral, activeShadow].join(',')
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({}, idle), resetFocus(focus, idle)), {}, _defineProperty(_defineProperty(_defineProperty({}, hoverSelector, _objectSpread2(_objectSpread2({}, hover), resetFocus(_objectSpread2(_objectSpread2({}, focus), {}, {
    boxShadow: [focus.boxShadow, hoverShadow].join(',')
  }), hover))), activeSelector, _objectSpread2(_objectSpread2({}, active), resetFocus(_objectSpread2(_objectSpread2({}, focus), {}, {
    boxShadow: [focus.boxShadow, activeShadow].join(',')
  }), active))), disabledSelector, {
    backgroundColor: 'transparent',
    borderColor: 'neutral.disabled',
    color: 'neutral.disabled'
  }));
};

/**
 * Build styles for `minimal` button fill variant
 *
 * @param props `Button` props
 * @returns
 */
var colorForMinimal = function colorForMinimal(_ref5) {
  var colorScheme = _ref5.colorScheme,
    theme = _ref5.theme;
  var _getInversePalette2 = getInversePalette(colorScheme, theme),
    color = _getInversePalette2.color,
    hoverColor = _getInversePalette2.hoverColor,
    hoverBackground = _getInversePalette2.hoverBackground,
    activeColor = _getInversePalette2.activeColor,
    activeBackground = _getInversePalette2.activeBackground;
  var idle = {
    borderColor: transparentize(1, hoverColor),
    shadow: 'invisibleNeutral'
  };
  return _objectSpread2(_objectSpread2(_objectSpread2({
    backgroundColor: 'transparent',
    color: color
  }, resetFocus(getFocus(colorScheme, theme), idle)), idle), {}, _defineProperty({
    ':hover:not([disabled])': {
      color: hoverColor,
      backgroundColor: hoverBackground
    },
    ':active:not([disabled])': {
      color: activeColor,
      backgroundColor: activeBackground
    }
  }, disabledSelector, {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'neutral.disabled'
  }));
};

var Button = {
  baseStyle: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
    alignItems: 'center',
    borderRadius: '300',
    border: 'unset',
    borderStyle: 'solid',
    borderWidth: '400',
    borderColor: 'transparent',
    boxSizing: 'border-box',
    display: 'flex',
    fontFamily: 'body',
    fontWeight: 'bold',
    gap: '200',
    justifyContent: 'center',
    overflow: 'hidden'
  }, /*#__PURE__*/transitions(['color', 'background', 'border', 'box-shadow'], motion.easings[250])), {}, {
    cursor: 'pointer',
    _disabled: {
      cursor: 'default'
    }
  }),
  variants: {
    minimal: function minimal(props) {
      return colorForMinimal(props);
    },
    outline: function outline(props) {
      return colorForOutline(props);
    },
    solid: function solid(props) {
      return colorForSolid(props);
    }
  },
  sizes: /*#__PURE__*/_mergeDeepRight(buttonSizes, {
    small: {
      textStyle: 'body400'
    },
    medium: {
      textStyle: 'body500'
    },
    "default": {
      textStyle: 'body500'
    },
    large: {
      textStyle: 'body500'
    }
  }),
  defaultProps: {
    colorScheme: 'neutral',
    size: 'default',
    variant: 'solid'
  }
};

var _excluded$4 = ["container"];
var $size = /*#__PURE__*/cssVar('check-control-size');
var container = {
  alignItems: 'center',
  color: 'neutral.700',
  display: 'inline-flex',
  fontFamily: 'body',
  fontWeight: 'body'
};
var control = function control(_ref) {
  var isInvalid = _ref.isInvalid;
  return _objectSpread2(_objectSpread2({}, transitions(['background', 'border', 'box-shadow'], motion.easings[250])), {}, {
    _checked: {
      background: isInvalid ? 'danger.500' : 'primary.600',
      border: isInvalid ? 'invalid' : 'primary'
    },
    _focus: {
      border: isInvalid ? 'invalidFocus' : 'focus',
      shadow: isInvalid ? 'haloDanger' : 'haloPrimary',
      _checked: {
        border: isInvalid ? 'invalidFocus' : 'focus'
      }
    },
    _disabled: {
      background: 'neutral.100',
      cursor: 'not-allowed',
      borderColor: 'neutral.300',
      _hover: {
        borderColor: 'neutral.300'
      },
      _after: {
        background: 'neutral.100'
      },
      _checked: {
        borderColor: 'neutral.300',
        background: 'neutral.300'
      }
    }
  });
};
var controlNext = function controlNext(_ref2) {
  var isInvalid = _ref2.isInvalid;
  return _objectSpread2(_objectSpread2({}, transitions(['background', 'border', 'box-shadow'], motion.easings[250])), {}, {
    _checked: {
      background: isInvalid ? 'danger.500' : 'neutral.900',
      borderColor: isInvalid ? 'border.invalid' : 'neutral.900'
    },
    _focus: {
      shadow: isInvalid ? 'haloDanger' : 'haloNeutral',
      _checked: {
        border: isInvalid ? 'invalidFocus' : 'neutral.900'
      }
    },
    _disabled: {
      background: 'neutral.100',
      cursor: 'not-allowed',
      borderColor: 'neutral.300',
      _hover: {
        borderColor: 'neutral.300'
      },
      _after: {
        background: 'neutral.100'
      },
      _checked: {
        borderColor: 'neutral.300'
      }
    }
  });
};
var label = function label(_ref3) {
  var isInvalid = _ref3.isInvalid;
  return _objectSpread2({
    color: isInvalid ? 'danger.700' : 'inherit',
    cursor: 'pointer',
    insetEnd: 400,
    _disabled: {
      color: 'neutral.500',
      cursor: 'default'
    }
  }, transitions(['color'], motion.easings[250]));
};

/**
 * Conditionally add a vertical offset to control when `alignItems` is set to
 * `baseline` to align control with first line of the label when the label wraps
 *
 * @param offset vertical offset in pixels
 * @param alignItems align-items style prop (allows this offset to be overridden)
 * @returns translation to apply to control's `transform`
 */
var getTransform = function getTransform(offset, alignItems) {
  return alignItems && mapResponsive(function (v) {
    return v === 'baseline' ? "translateY(".concat(offset, "px)") : 'none';
  }, alignItems);
};
var capsizeUnlessBaseline = function capsizeUnlessBaseline(style, alignItems) {
  var _mapResponsive;
  var capsizeStyle = "".concat(style, "WithCapsize");
  return (_mapResponsive = mapResponsive(function (v) {
    return v === 'baseline' ? style : capsizeStyle;
  }, alignItems, capsizeStyle)) !== null && _mapResponsive !== void 0 ? _mapResponsive : capsizeStyle;
};
var sizes$6 = {
  small: function small(_ref4) {
    var alignItems = _ref4.alignItems;
    return {
      container: _defineProperty({}, $size.variable, 'sizes.checkbox.small'),
      control: {
        transform: getTransform(2, alignItems)
      },
      label: {
        textStyle: capsizeUnlessBaseline('body400', alignItems)
      }
    };
  },
  medium: function medium(_ref5) {
    var alignItems = _ref5.alignItems;
    return {
      container: _defineProperty({}, $size.variable, 'sizes.checkbox.medium'),
      control: {
        transform: getTransform(3, alignItems)
      },
      label: {
        textStyle: capsizeUnlessBaseline('body500', alignItems)
      }
    };
  },
  large: function large(_ref6) {
    var alignItems = _ref6.alignItems;
    return {
      container: _defineProperty({}, $size.variable, 'sizes.checkbox.large'),
      control: {
        transform: getTransform(4, alignItems)
      },
      label: {
        textStyle: capsizeUnlessBaseline('body600', alignItems)
      }
    };
  }
};
var getTileContainerSize = function getTileContainerSize(size) {
  switch (size) {
    case 'small':
      return {
        padding: 200,
        gridTemplateRows: "".concat(cssVarPrefixed('lineHeights-200').reference, " 1fr"),
        gridColumnGap: 200
      };
    case 'large':
      return {
        padding: 400,
        gridTemplateRows: "".concat(cssVarPrefixed('lineHeights-400').reference, " 1fr"),
        gridColumnGap: 400
      };
    default:
      return {
        padding: 300,
        gridTemplateRows: "".concat(cssVarPrefixed('lineHeights-300').reference, " 1fr"),
        gridColumnGap: 300
      };
  }
};
var tileControlHoverSelector = /*#__PURE__*/['.chakra-checkbox:not([data-disabled]):hover &', '.chakra-radio:not([data-disabled]):hover &'].join(',');
var tile = function tile(_ref7) {
  var isInvalid = _ref7.isInvalid,
    size = _ref7.size,
    isNext = _ref7.theme.components.isNext;
  return {
    container: _objectSpread2(_objectSpread2({}, getTileContainerSize(size)), {}, {
      borderColor: isInvalid ? 'danger.300' : 'neutral.500',
      borderRadius: 300,
      borderStyle: 'solid',
      borderWidth: 400,
      cursor: 'pointer',
      display: 'grid',
      fontFamily: 'body',
      fontWeight: 'body',
      gridTemplateAreas: "\n        \"control label\"\n        \". description\"\n      ",
      gridTemplateColumns: 'min-content 1fr',
      justifyContent: 'start',
      _disabled: {
        borderColor: 'neutral.300',
        cursor: 'default'
      },
      _checked: {
        borderColor: isInvalid ? 'danger.700' : 'primary.700',
        background: isInvalid ? 'danger.100' : 'primary.100',
        _disabled: {
          borderColor: 'neutral.400',
          background: 'neutral.100'
        }
      },
      ':hover:not([data-disabled]):not([data-checked])': {
        borderColor: isInvalid ? 'danger.700' : 'primary.700',
        background: isInvalid ? 'danger.50' : 'primary.50'
      }
    }, transitions(['border', 'background'], motion.easings[250])),
    control: _defineProperty({
      alignSelf: 'center',
      justifyContent: 'center',
      gridArea: 'control'
    }, tileControlHoverSelector, isNext ? {} : {
      borderColor: isInvalid ? 'danger.700' : 'primary.700'
    }),
    label: {
      display: 'grid',
      gridRowGap: 100,
      gridRowStart: 1,
      gridRowEnd: 3,
      gridColumnStart: 2,
      gridColumnEnd: 3,
      margin: 0,
      overflow: 'hidden',
      // Disable Capsize altogether on the tile label element because it can
      // container more than just simple text content and Capsize screws up
      // the alignment of child elements
      _before: {
        display: 'none'
      },
      _after: {
        display: 'none'
      }
    }
  };
};
var variants = {
  "default": {},
  tile: tile,
  'subtle-tile': function subtleTile(props) {
    var _tile = tile(props),
      baseContainer = _tile.container,
      rest = _objectWithoutProperties(_tile, _excluded$4);
    var isInvalid = props.isInvalid;
    var fill = isInvalid ? 'danger.100' : 'primary.100';
    return _objectSpread2({
      container: _objectSpread2(_objectSpread2({}, baseContainer), {}, {
        borderColor: 'transparent',
        _checked: {
          borderColor: isInvalid ? 'danger.300' : 'primary.300',
          background: fill,
          _disabled: {
            borderColor: 'neutral.400',
            background: 'neutral.100'
          }
        },
        ':hover:not([data-disabled]):not([data-checked])': {
          borderColor: fill,
          background: fill
        }
      })
    }, rest);
  }
};

var _excluded$3 = ["theme"];
var Checkbox = {
  defaultProps: {
    size: 'default',
    variant: 'default'
  },
  parts: ['container', 'control', 'label', 'icon'],
  baseStyle: function baseStyle(_ref) {
    var isNext = _ref.theme.components.isNext,
      props = _objectWithoutProperties(_ref, _excluded$3);
    var checkboxProps = props;
    var isInvalid = checkboxProps.isInvalid,
      size = checkboxProps.size;
    var focus = isNext ? 'haloNeutral' : 'haloPrimary';
    var focusBorder = isNext ? 'neutral.900' : 'border.focus';
    var hoverBorder = isNext ? 'neutral.900' : 'primary.700';
    var checkedBorder = isNext ? 'neutral.900' : 'border.primary';
    return {
      container: container,
      label: label(checkboxProps),
      icon: _objectSpread2({
        background: 'neutral.0',
        borderColor: 'inherit',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 400,
        boxSizing: 'border-box',
        fill: 'none',
        height: '100%',
        overflow: 'hidden',
        stroke: 'neutral.0',
        width: '100%'
      }, transitions(['border'], motion.easings[250])),
      control: _objectSpread2({
        width: $size.reference,
        height: $size.reference,
        border: isInvalid ? 'danger' : 'neutral',
        borderRadius: size === 'small' || isNext ? 200 : 300,
        borderWidth: 0,
        boxSizing: 'border-box',
        cursor: 'pointer',
        shadow: 'invisibleNeutral',
        // NOTE: The `icon` part isn't currently responding to `_checked` etc.,
        // so we're setting `borderWidth` to zero and `borderColor` on the
        // `control` part and inheriting said `borderColor` on the `icon`.
        _checked: {
          borderColor: isInvalid ? 'border.invalid' : checkedBorder
        },
        _disabled: {
          cursor: 'not-allowed',
          borderColor: 'border.disabled'
        },
        _hover: {
          borderColor: isInvalid ? 'danger.700' : hoverBorder,
          _disabled: {
            borderColor: 'border.disabled'
          }
        },
        _focus: {
          borderColor: isInvalid ? 'border.invalidFocus' : focusBorder,
          shadow: isInvalid ? 'haloDanger' : focus
        }
      }, transitions(['border', 'box-shadow', 'background'], motion.easings[250]))
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$6), {}, {
    "default": sizes$6.medium
  }),
  variants: variants
};

var colorsFor = function colorsFor(_ref) {
  var colorScheme = _ref.colorScheme,
    variant = _ref.variant;
  var hoverShade = variant === 'minimal' ? '100' : '200';
  switch (colorScheme) {
    case 'primary':
      return {
        bg: 'primary.100',
        _hover: {
          bg: "primary.".concat(hoverShade)
        },
        _focus: {
          bg: "primary.".concat(hoverShade)
        }
      };
    case 'success':
      return {
        bg: 'success.100',
        _hover: {
          bg: "success.".concat(hoverShade)
        },
        _focus: {
          bg: "success.".concat(hoverShade)
        }
      };
    case 'warning':
      return {
        bg: 'warning.100',
        _hover: {
          bg: "warning.".concat(hoverShade)
        },
        _focus: {
          bg: "warning.".concat(hoverShade)
        }
      };
    case 'danger':
      return {
        bg: 'danger.100',
        _hover: {
          bg: "danger.".concat(hoverShade)
        },
        _focus: {
          bg: "danger.".concat(hoverShade)
        }
      };
    default:
      {
        var neutralHoverShade = variant === 'minimal' ? '200' : '300';
        return {
          bg: variant === 'minimal' ? 'neutral.100' : 'neutral.200',
          _hover: {
            bg: "neutral.".concat(neutralHoverShade)
          },
          _focus: {
            bg: "neutral.".concat(neutralHoverShade)
          }
        };
      }
  }
};
var CloseButton = {
  defaultProps: {
    size: 'default',
    variant: 'solid'
  },
  baseStyle: function baseStyle(props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({
      border: 'none',
      borderRadius: '200',
      cursor: 'pointer',
      outline: 'none',
      shadow: 'none'
    }, transitions(['background', 'border'], motion.easings[250])), _mergeDeepRight({
      _hover: {
        svg: {
          color: 'neutral.700'
        }
      },
      _focus: {
        shadow: 'none'
      }
    }, colorsFor(props))), {}, {
      svg: _objectSpread2(_objectSpread2({}, transitions(['color'], motion.easings[250])), {}, {
        color: 'neutral.600',
        overflow: 'visible',
        strokeLinecap: 'round',
        strokeWidth: '2px'
      }),
      _focusVisible: {
        outline: 'none'
      }
    });
  },
  sizes: {
    small: {
      width: '20px',
      height: '20px',
      svg: {
        width: '50',
        height: '50'
      }
    },
    "default": {
      width: '200',
      height: '200',
      svg: {
        width: '75',
        height: '75'
      }
    },
    large: {
      width: '300',
      height: '300',
      svg: {
        width: '75',
        height: '75'
      }
    }
  },
  variants: {
    minimal: {
      bg: 'transparent',
      _hover: {}
    },
    solid: {},
    soft: function soft(_ref2) {
      var colorScheme = _ref2.colorScheme,
        colors = _ref2.theme.colors;
      return _objectSpread2(_objectSpread2({}, colors.softColorFor(colorScheme)), {}, {
        _hover: _objectSpread2({}, colors.softColorFor(colorScheme, true))
      });
    }
  }
};

var Code = {
  defaultProps: {
    colorScheme: 'neutral',
    size: 500,
    variant: 'default'
  },
  baseStyle: function baseStyle(_ref) {
    var colorScheme = _ref.colorScheme,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      isNext = _ref$theme.components.isNext;
    return _objectSpread2({
      borderRadius: isNext ? 200 : 300,
      fontFamily: 'mono',
      paddingX: 100,
      textDecoration: 'inherit'
    }, colors.softColorFor(colorSchemeWithDefault(colorScheme, 'neutral')));
  },
  sizes: /*#__PURE__*/fromEntries( /*#__PURE__*/textSize.map(function (size) {
    return [size, {
      textStyle: "code".concat(size)
    }];
  })),
  variants: {
    "default": {},
    brand: {
      borderRadius: 500,
      paddingX: 200
    },
    outline: function outline(_ref2) {
      var colorScheme = _ref2.colorScheme;
      return {
        background: 'transparent',
        borderWidth: '400',
        borderStyle: 'solid',
        borderColor: "".concat(colorScheme !== null && colorScheme !== void 0 ? colorScheme : 'neutral', ".200")
      };
    },
    minimal: {
      background: 'transparent',
      border: 'none'
    },
    dark: function dark(_ref3) {
      var colorScheme = _ref3.colorScheme,
        colors = _ref3.theme.colors;
      return colors.softColorFor(colorSchemeWithDefault(colorScheme, 'neutral'), true);
    }
  }
};

var Decoration = {
  baseStyle: {
    fill: 'none',
    stroke: 'currentColor'
  },
  defaultProps: {
    size: 'small'
  },
  sizes: iconSizes,
  variants: {}
};

var Divider = {
  defaultProps: {
    colorScheme: 'neutral',
    orientation: 'horizontal',
    variant: 'subtle',
    size: 'default'
  },
  baseStyle: {
    opacity: 1,
    borderStyle: 'solid'
  },
  sizes: {
    small: function small(_ref) {
      var orientation = _ref.orientation;
      return _defineProperty({}, orientation === 'horizontal' ? 'borderBottomWidth' : 'borderRightWidth', 400);
    },
    "default": function _default(_ref3) {
      var orientation = _ref3.orientation;
      return _defineProperty(_defineProperty({}, orientation === 'horizontal' ? 'borderBottomWidth' : 'borderRightWidth', 500), orientation === 'horizontal' ? 'marginY' : 'marginX', 400);
    }
  },
  variants: {
    subtle: function subtle(_ref5) {
      var colorScheme = _ref5.colorScheme,
        colors = _ref5.theme.colors;
      var _colors$softColorFor = colors.softColorFor(colorScheme),
        borderColor = _colors$softColorFor.backgroundColor;
      return {
        borderColor: borderColor
      };
    }
  }
};

/**
 * Chakra doesn't currently make the `placement` prop available here so we
 * don't know whether the drawer is coming from the top/bottom or left/right. We
 * need to set `box-sizing` to `border-box` for top/bottom to be sized
 * correctly, but still want `content-box` for left/right so just compute it 🤷🏻‍♂️
 *
 * @param width size token for drawer width;
 * @param padding space token for drawer padding
 * @returns width in pixels
 */
var maxWidthFor = function maxWidthFor(width, padding) {
  return math("".concat(sizes$9[width], " + ").concat(space[padding], " * 2"));
};
var sizes$5 = /*#__PURE__*/_mergeDeepRight(sizes$8, {
  full: {
    dialog: {
      maxWidth: '100%',
      boxSizing: 'border-box'
    }
  },
  small: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(700, 500),
      boxSizing: 'border-box'
    }
  },
  medium: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(750, 600),
      boxSizing: 'border-box'
    }
  },
  large: {
    dialog: {
      maxWidth: /*#__PURE__*/maxWidthFor(800, 600),
      boxSizing: 'border-box'
    }
  }
});
var Drawer = {
  defaultProps: {
    size: 'default',
    variant: 'default'
  },
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: /*#__PURE__*/_mergeDeepRight(baseStyle, {
    body: {
      flex: 1
    },
    dialog: {
      boxSizing: 'border-box'
    },
    dialogContainer: {
      zIndex: 'modal'
    },
    footer: {
      flexShrink: 0
    },
    header: {
      flexShrink: 0
    }
  }),
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$5), {}, {
    "default": /*#__PURE__*/mergeSizesToResponsive( /*#__PURE__*/_objectSpread2({
      tiny: sizes$5.full
    }, sizes$5))
  }),
  variants: {
    "default": {},
    persistent: {
      dialog: {
        pointerEvents: 'auto'
      },
      dialogContainer: {
        pointerEvents: 'none'
      }
    }
  }
};

var inputParts = ['preview', 'input'];

// These common `sizes` were originally meant for `Input` and `Select`, etc.
// where the theme part is `editor`. We want to apply those sizes to theme
// parts `preview` and `input` instead
var sizes$4 = /*#__PURE__*/fromEntries( /*#__PURE__*/entries(sizes$a).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    sizeName = _ref2[0],
    size = _ref2[1];
  return [sizeName, fromEntries(entries(size).flatMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      styles = _ref4[1];
    return inputParts.map(function (part) {
      return [part, styles];
    });
  }))];
}));
var Editable = {
  defaultProps: {
    size: 'default'
  },
  parts: /*#__PURE__*/[].concat(inputParts),
  baseStyle: function baseStyle(_ref5) {
    var colors = _ref5.theme.colors;
    return {
      preview: {
        border: '1px solid transparent',
        boxSizing: 'border-box',
        fontFamily: 'body',
        fontWeight: 'body',
        cursor: '',
        _hover: {
          background: colors.alpha(0.75, 'primary.400')
        },
        '&[hidden]': {
          display: 'none'
        },
        width: '100%'
      },
      input: _objectSpread2({
        boxSizing: 'border-box',
        maxWidth: '100%',
        _focus: {
          shadow: ''
        },
        '&[hidden]': {
          display: 'none',
          // A bit of a hack, but this hides the caret of `Select`
          // properly when doing `<EditableInput as={Select} />`
          '& + *': {
            display: 'none'
          }
        }
      }, field({
        isInvalid: false
      }))
    };
  },
  sizes: sizes$4,
  variants: {}
};

var Form = {
  parts: ['container', 'helperText', 'requiredIndicator'],
  baseStyle: {
    container: {
      // Reset for when we render a `fieldset`
      border: 'none',
      margin: 0,
      padding: 0
    },
    helperText: {
      textStyle: 'body400',
      fontFamily: 'body',
      fontWeight: 'body',
      color: 'neutral.600'
    },
    requiredIndicator: /*#__PURE__*/_objectSpread2({
      textStyle: 'body400',
      fontFamily: 'body',
      fontWeight: 'body',
      color: 'neutral.600',
      marginLeft: 200
    }, /*#__PURE__*/transitions(['color'], motion.easings[250]))
  },
  sizes: {
    "default": {},
    small: {},
    tiny: {}
  },
  variants: {}
};

var FormError = {
  defaultProps: {},
  baseStyle: {
    text: {
      textStyle: 'body400',
      color: 'danger.500',
      fontFamily: 'body',
      fontWeight: 'body'
    }
  },
  sizes: {
    "default": {},
    small: {},
    tiny: {}
  },
  variants: {}
};

var FormLabel = {
  defaultProps: {},
  baseStyle: /*#__PURE__*/_objectSpread2({
    textStyle: 'body400',
    fontWeight: 'bodySemiBold',
    fontFamily: 'body',
    color: 'neutral.600',
    marginBottom: 100
  }, /*#__PURE__*/transition.easing250('color')),
  sizes: {
    "default": {},
    small: {},
    tiny: {}
  },
  variants: {}
};

var Heading = {
  baseStyle: {
    color: 'neutral.text'
  },
  defaultProps: {
    size: 600,
    variant: 'default'
  },
  sizes: /*#__PURE__*/fromEntries( /*#__PURE__*/headingSize.map(function (size) {
    return [size, {
      textStyle: "heading".concat(size, "WithMargin")
    }];
  })),
  variants: {
    "default": {
      fontFamily: 'heading',
      fontWeight: 'heading'
    },
    display: {
      fontFamily: 'heading',
      fontWeight: 'display'
    },
    light: {
      fontFamily: 'heading',
      fontWeight: 'headingLight'
    }
  }
};

var Input = {
  parts: ['addon', 'field', 'element'],
  defaultProps: {
    size: 'default'
  },
  baseStyle: function baseStyle(props) {
    return {
      field: field(props),
      addon: {
        background: 'neutral.200',
        borderRadius: 300,
        border: 'idle'
      },
      element: {
        '&.icon': {
          color: 'neutral.500'
        }
      }
    };
  },
  sizes: sizes$a,
  variants: {
    "default": {}
  }
};

var Kbd = {
  defaultProps: {
    colorScheme: 'neutral',
    size: 500
  },
  baseStyle: function baseStyle(_ref) {
    var colorScheme = _ref.colorScheme,
      colors = _ref.theme.colors;
    var _colors$softColorFor = colors.softColorFor(colorScheme),
      color = _colors$softColorFor.color,
      backgroundColor = _colors$softColorFor.backgroundColor;
    return {
      color: color,
      borderStyle: 'solid',
      borderColor: color,
      backgroundColor: backgroundColor,
      fontFamily: 'body',
      borderWidth: '1px',
      lineHeight: '100%',
      fontVariant: 'small-caps',
      fontWeight: 'bodySemiBold',
      whitespace: 'nowrap'
    };
  },
  sizes: /*#__PURE__*/_mergeDeepRight(textSizes, {
    '200': {
      borderRadius: 300,
      borderBottomWidth: '2px'
    },
    '300': {
      borderRadius: 300,
      paddingX: 50,
      borderBottomWidth: '2px'
    },
    '400': {
      borderRadius: 400,
      paddingX: 100,
      borderBottomWidth: '2px'
    },
    '500': {
      borderRadius: 400,
      paddingX: 200,
      borderBottomWidth: '2px'
    },
    '600': {
      borderRadius: 500,
      paddingX: 300,
      borderBottomWidth: '3px'
    }
  }),
  variants: {}
};

var _excluded$2 = ["as"];
var Link = {
  defaultProps: {
    // NOTE: not defaulting `size` because we want links
    // to inherit `font-size` and `line-height` by default
    colorScheme: 'primary',
    variant: 'underline'
  },
  // When the `as` prop is passed, we assume we're not rendering an anchor
  // tag and therefore we apply interaction styles unconditionally. When
  // rendering an anchor tag, only make the link look interactive when the
  // `href` attribute is present.
  baseStyle: function baseStyle(_ref) {
    var as = _ref.as,
      props = _objectWithoutProperties(_ref, _excluded$2);
    return link(props, as ? false : '[href]');
  },
  sizes: sizes$b,
  variants: {
    // When the `as` prop is passed, we assume we're not rendering an anchor
    // tag and therefore we apply interaction styles unconditionally. When
    // rendering an anchor tag, only make the link look interactive when the
    // `href` attribute is present.
    underline: function underline$1(_ref2) {
      var as = _ref2.as;
      return underline(as ? false : '[href]');
    },
    minimal: {
      textDecoration: 'none',
      _hover: {
        textDecoration: 'none'
      }
    },
    'persistent-underline': function persistentUnderline(_ref3) {
      var as = _ref3.as;
      return _objectSpread2(_objectSpread2({}, underline(as ? false : '[href]')), {}, {
        textDecorationColor: 'currentColor'
      });
    }
  }
};

var sizes$3 = {
  small: {
    container: {
      paddingLeft: '300'
    },
    icon: {
      width: '50',
      height: '50',
      marginTop: '0.5em',
      textStyle: 'body400'
    },
    item: {
      textStyle: 'body400'
    }
  },
  medium: {
    container: {
      paddingLeft: '500'
    },
    icon: {
      width: '75',
      height: '75',
      marginTop: '0.4em',
      textStyle: 'body500'
    },
    item: {
      textStyle: 'body500'
    }
  },
  large: {
    container: {
      paddingLeft: '600'
    },
    icon: {
      width: '100',
      height: '100',
      marginTop: '0.35em',
      textStyle: 'body600'
    },
    item: {
      textStyle: 'body600'
    }
  }
};
var List = {
  defaultProps: {
    size: 'default'
  },
  parts: ['container', 'icon', 'item'],
  baseStyle: {
    container: {
      margin: 0
    },
    icon: {
      transform: "translateX(calc(-100% - 0.4em))",
      margin: 0,
      display: 'inline-block',
      position: 'absolute'
    },
    item: {
      color: 'neutral.text',
      padding: 0,
      position: 'relative',
      fontFamily: 'body',
      fontWeight: 'body'
    }
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$3), {}, {
    "default": sizes$3.medium
  }),
  variants: {
    menu: function menu(props) {
      var _menuVariants$default = variants$1["default"](props),
        item = _menuVariants$default.item;
      return {
        item: _objectSpread2(_objectSpread2({}, item), {}, {
          '&[aria-selected=true]': {
            background: 'primary.100'
          }
        }),
        container: {
          padding: 0
        }
      };
    }
  }
};

var parts$1 = ['button', 'list', 'item', 'groupTitle', 'command', 'divider'];
var Menu = {
  defaultProps: {
    variant: 'default'
  },
  parts: parts$1,
  baseStyle: variants$1["default"],
  sizes: {},
  variants: {
    "default": {},
    navigation: function navigation(_ref) {
      var colorScheme = _ref.colorScheme,
        colors = _ref.theme.colors;
      var indicatorThickness = '4px';
      var hover = _objectSpread2(_objectSpread2({}, colors.softColorFor(colorScheme)), {}, {
        _before: {
          borderLeftWidth: indicatorThickness,
          opacity: 1
        }
      });
      return {
        divider: {
          color: 'neutral.400',
          marginX: 600,
          marginY: 400
        },
        groupTitle: {
          color: 'neutral.600',
          paddingX: 600,
          paddingY: 200,
          textTransform: 'uppercase',
          textStyle: 'body400'
        },
        item: _objectSpread2(_objectSpread2({
          position: 'relative',
          paddingX: 800,
          paddingY: 100
        }, transitions(['color'], motion.easings[250])), {}, {
          _before: _objectSpread2({
            content: '""',
            position: 'absolute',
            borderColor: hover.color,
            borderWidth: 0,
            borderStyle: 'solid',
            left: 0,
            opacity: 0,
            width: '100%',
            height: '100%'
          }, transitions(['border', 'opacity'], motion.easings[250])),
          _hover: hover,
          _focus: hover
        }),
        list: {
          borderRadius: 500,
          paddingTop: 400,
          paddingBottom: 500,
          shadow: 'distance400'
        }
      };
    }
  }
};

var PinInput = {
  defaultProps: {
    size: 'default'
  },
  baseStyle: function baseStyle(props) {
    return _objectSpread2(_objectSpread2({}, field(props)), {}, {
      width: 'auto',
      _placeholder: {
        color: 'neutral.400',
        textAlign: 'center'
      }
    });
  },
  sizes: /*#__PURE__*/mapValues(sizes$a, function (_ref) {
    var size = _ref.field;
    var height = size.height;
    return _objectSpread2(_objectSpread2({}, size), {}, {
      width: height
    });
  }),
  variants: {}
};

var Popover = {
  defaultProps: {},
  parts: ['popper', 'content', 'header', 'body', 'footer', 'arrow', 'closeButton'],
  baseStyle: function baseStyle(_ref) {
    var colorScheme = _ref.colorScheme;
    var background = colorScheme === 'dark' ? 'neutral.700' : 'neutral.0';
    return {
      arrow: {
        '--popper-arrow-bg': variables.color(background).reference,
        '--popper-arrow-shadow-color': variables.color('darkAlpha.200').reference
      },
      popper: {
        zIndex: 'popover'
      },
      body: {
        paddingX: 0,
        width: '100%'
      },
      closeButton: {
        borderRadius: 200,
        opacity: 0.8,
        padding: 0,
        position: 'absolute',
        right: 200,
        top: 200
      },
      content: _objectSpread2({
        gap: 300,
        background: background,
        border: 'none',
        boxSizing: 'border-box',
        color: colorScheme === 'dark' ? 'neutral.0' : 'neutral.900',
        zIndex: 'inherit',
        borderRadius: 300,
        fontFamily: 'body',
        padding: 400,
        shadow: 'distance300',
        width: 700,
        outline: 'none',
        _focus: {
          shadow: [shadows.distance300, shadows.ringNeutral].join(',')
        }
      }, transitions(['box-shadow'], motion.easings[250])),
      header: {
        fontWeight: 'heading'
      },
      footer: {}
    };
  },
  sizes: {},
  variants: {}
};

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var animation = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { background-position: 100% 0% }\n  100% { background-position: -100% 0% }\n"])));
var parts = progressAnatomy.keys;
var getGradient = function getGradient(_ref) {
  var isAnimated = _ref.isAnimated,
    isIndeterminate = _ref.isIndeterminate,
    filled = _ref.filled,
    track = _ref.track,
    colors = _ref.theme.colors;
  if (!isAnimated && !isIndeterminate) return undefined;
  var color = isAnimated ? colors.alpha(0.8, track) : colors.alpha(0.7, filled);
  return "\n    linear-gradient(\n      to right,\n      transparent 0%,\n      transparent 20%,\n      ".concat(color, " 45%,\n      ").concat(color, " 55%,\n      transparent 70%,\n      transparent 100%\n    )\n  ");
};
var Progress = {
  defaultProps: {
    size: 'medium',
    colorScheme: 'primary',
    variant: 'solid'
  },
  parts: parts,
  baseStyle: function baseStyle(_ref2) {
    var colorScheme = _ref2.colorScheme,
      isAnimated = _ref2.isAnimated,
      isIndeterminate = _ref2.isIndeterminate,
      theme = _ref2.theme,
      isNext = _ref2.theme.components.isNext;
    var _theme$colors$softCol = theme.colors.softColorFor(colorScheme),
      legacyFilledColor = _theme$colors$softCol.color,
      legacyBackgroundColor = _theme$colors$softCol.backgroundColor;
    var filledColor = isNext && colorScheme === 'neutral' ? 'neutral.900' : legacyFilledColor;
    var backgroundColor = isNext && colorScheme === 'neutral' ? 'neutral.200' : legacyBackgroundColor;
    return {
      track: {
        shadow: isNext ? undefined : 'inset100',
        backgroundColor: backgroundColor,
        overflow: 'hidden'
      },
      filledTrack: _objectSpread2(_objectSpread2({
        backgroundColor: isIndeterminate ? undefined : filledColor,
        opacity: 0.9,
        borderRightRadius: '1px !important',
        borderLeftRadius: '1px !important'
      }, transition.easing150('width')), {}, {
        willChange: 'width, left',
        animation: isAnimated ? "".concat(animation, " 1s infinite linear") : undefined,
        backgroundPosition: isIndeterminate ? '40%' : undefined,
        backgroundSize: '200% 100%',
        backgroundImage: getGradient({
          isAnimated: isAnimated,
          isIndeterminate: isIndeterminate,
          filled: filledColor,
          track: backgroundColor,
          theme: theme
        })
      })
    };
  },
  sizes: {
    small: {
      track: {
        height: 50
      }
    },
    medium: {
      track: {
        height: 100
      }
    },
    large: {
      track: {
        height: 200
      }
    }
  },
  variants: {
    solid: function solid(_ref3) {
      var isNext = _ref3.theme.components.isNext;
      return {
        track: {
          borderRadius: isNext ? 0 : 300
        }
      };
    },
    brand: {
      track: {
        borderRadius: 400
      }
    }
  }
};

var _excluded$1 = ["theme"];
var $controlSize = /*#__PURE__*/cssVar('radio-control-size');
var $checkedSize = /*#__PURE__*/cssVar('radio-checked-size');
var Radio = {
  defaultProps: {
    size: 'default'
  },
  parts: ['container', 'control', 'label'],
  baseStyle: function baseStyle(_ref) {
    var isNext = _ref.theme.components.isNext,
      props = _objectWithoutProperties(_ref, _excluded$1);
    var radioProps = props;
    var isInvalid = radioProps.isInvalid;
    var uncheckedSize = calc.subtract($size, '2px');
    var hoverBorder = isNext ? 'neutral.900' : 'primary.700';
    return {
      container: _objectSpread2(_objectSpread2({}, container), {}, _defineProperty(_defineProperty({}, $controlSize.variable, $size.reference), $checkedSize.variable, calc.divide(calc.subtract($size, '2px'), 2))),
      label: label(radioProps),
      control: _mergeDeepRight(isNext ? controlNext(radioProps) : control(radioProps), {
        border: isInvalid ? 'danger' : 'neutral',
        borderRadius: 900,
        background: 'neutral.0',
        boxSizing: 'border-box',
        shadow: 'invisibleNeutral',
        cursor: 'pointer',
        width: $controlSize.reference,
        height: $controlSize.reference,
        position: 'relative',
        _after: _objectSpread2({
          width: uncheckedSize,
          height: uncheckedSize,
          background: 'neutral.0',
          borderRadius: 900,
          content: '""',
          position: 'absolute'
        }, transitions(['height', 'width'], motion.easings[250])),
        _checked: {
          _after: {
            width: $checkedSize.reference,
            height: $checkedSize.reference
          }
        },
        _hover: {
          borderColor: isInvalid ? 'danger.700' : hoverBorder
        }
      })
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$6), {}, {
    "default": sizes$6.medium
  }),
  variants: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, variants), {}, {
    filled: function filled() {
      return {
        container: _defineProperty(_defineProperty({}, $controlSize.variable, calc.subtract($size, '2px')), $checkedSize.variable, calc.subtract($controlSize, '4px')),
        control: {
          _focus: {
            shadow: 'none'
          },
          _focusVisible: {
            shadow: 'haloNeutral',
            _invalid: {
              shadow: 'haloDanger'
            }
          },
          _checked: {
            background: 'neutral.0'
          },
          _invalid: {
            _after: {
              background: 'danger.800'
            }
          },
          _after: {
            background: 'neutral.900',
            width: 0,
            height: 0
          },
          _disabled: {
            background: 'transparent',
            _after: {
              background: 'darkAlpha.300'
            }
          }
        }
      };
    }
  })
};

var $placeholderPaddingX = /*#__PURE__*/cssVar('select-placeholder-padding-x');
var Select = {
  defaultProps: {
    size: 'default'
  },
  parts: ['field', 'element'],
  baseStyle: function baseStyle(props) {
    return {
      field: _mergeDeepRight(field(props), {
        cursor: 'pointer',
        appearance: 'none',
        _focus: {
          '+ div': {
            color: props.isInvalid ? 'danger.700' : 'secondary.600'
          }
        },
        '> option, > optgroup': {
          bg: 'neutral.0'
        },
        '&[data-empty]': {
          color: 'transparent'
        },
        '&:not([data-empty])': {
          '& ~ .placeholder': {
            opacity: 0
          },
          color: 'neutral.900 !important'
        },
        '& ~ .placeholder': _objectSpread2({
          padding: $placeholderPaddingX.reference,
          display: 'inline-flex',
          alignItems: 'center',
          opacity: 1,
          pointerEvents: 'none',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0
        }, transition.easing250('opacity'))
      })
    };
  },
  sizes: /*#__PURE__*/_mergeDeepRight({
    "default": {
      field: {
        '& ~ .placeholder': /*#__PURE__*/_defineProperty({}, $placeholderPaddingX.variable, /*#__PURE__*/"space.".concat(paddingHorizontalMedium))
      }
    },
    small: {
      field: {
        '& ~ .placeholder': /*#__PURE__*/_defineProperty({}, $placeholderPaddingX.variable, /*#__PURE__*/"space.".concat(paddingHorizontalSmall))
      }
    },
    tiny: {
      field: {
        '& ~ .placeholder': /*#__PURE__*/_defineProperty({}, $placeholderPaddingX.variable, /*#__PURE__*/"space.".concat(paddingHorizontalTiny))
      }
    }
  }, sizes$a),
  variants: {}
};

var breakpoint = 'tablet';
var $padding = /*#__PURE__*/cssVar$1('padding');
var $closeButtonTop = /*#__PURE__*/cssVar$1('close-button-top');
var $closeButtonRight = /*#__PURE__*/cssVar$1('close-button-right');
var $width = /*#__PURE__*/cssVar$1('width');
var $motionOverflow = /*#__PURE__*/cssVar$1('motion-overflow');
var anchor = /*#__PURE__*/calc$1.multiply($motionOverflow, -1);
var defineStyle = function defineStyle(variant) {
  return function (base, right, modal) {
    var isModal = variant === 'modal' && !!modal;
    if (variant === 'bottom') {
      return base;
    }
    return _defineProperty({
      base: base
    }, breakpoint, isModal ? modal : right);
  };
};
var getMinHeightStyles = function getMinHeightStyles(variant, size) {
  if (size === 'full') {
    if (variant === 'bottom') {
      return calc$1.add('100vh', $motionOverflow);
    }
    if (variant === 'modal') {
      return _defineProperty({
        base: calc$1.add('100vh', $motionOverflow)
      }, breakpoint, 'auto');
    }
    if (variant === 'responsive') {
      return _defineProperty({
        base: calc$1.add('100vh', $motionOverflow)
      }, breakpoint, calc$1.subtract('100vh', $padding.reference));
    }
  }
  return undefined;
};
var responsiveDialogStyles = function responsiveDialogStyles(variant) {
  var define = defineStyle(variant);
  return {
    borderRadius: define(0, 0, 400),
    borderTopRadius: 0,
    width: define('100vw', calc$1.add($width, $motionOverflow), 'auto'),
    height: define('auto', '100%', 'auto'),
    maxHeight: define(calc$1.add($motionOverflow, '100vh'), 'unset', 'unset'),
    right: define('unset', anchor, 'unset'),
    bottom: define(anchor, 'unset', 'unset'),
    paddingTop: define('800', '900'),
    paddingBottom: define(calc$1.add($motionOverflow, $padding), $padding.reference, '700'),
    paddingRight: define($padding.reference, calc$1.add($motionOverflow, $padding), $padding.reference)
  };
};
var responsiveDialogContainerStyles = function responsiveDialogContainerStyles(variant) {
  var define = defineStyle(variant);
  return _defineProperty(_defineProperty({}, $closeButtonTop.variable, define('space.600', 'space.400')), $closeButtonRight.variable, 'space.400');
};
var responsiveCloseButtonStyles = function responsiveCloseButtonStyles(variant) {
  var define = defineStyle(variant);
  return {
    right: define($closeButtonRight.reference, calc$1.add($closeButtonRight, $motionOverflow))
  };
};
var Sheet = {
  defaultProps: {
    size: 'auto',
    variant: 'responsive'
  },
  parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  // NOTE: must be a function, see comments in slider and next/button theme
  baseStyle: function baseStyle$1(props) {
    var variant = props.variant,
      size = props.size;
    var minHeight = getMinHeightStyles(variant, size);
    return _mergeDeepRight(baseStyle, {
      dialog: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        outline: 0,
        minHeight: minHeight,
        paddingX: $padding.reference,
        zIndex: 'modal',
        position: 'fixed'
      },
      dialogContainer: _defineProperty(_defineProperty(_defineProperty({
        alignItems: 'center',
        display: 'flex',
        height: '$100vh',
        justifyContent: 'center',
        left: 0,
        overscrollBehaviorY: 'none',
        position: 'fixed',
        top: 0,
        width: '100vw',
        zIndex: 'modal'
      }, $motionOverflow.variable, 'space.1000'), $padding.variable, 'space.500'), $width.variable, 'sizes.750'),
      header: {
        textStyle: 'heading600',
        marginBottom: '300'
      },
      closeButton: {
        top: $closeButtonTop.reference,
        right: $closeButtonRight.reference
      }
    });
  },
  sizes: /*#__PURE__*/_mergeDeepRight(sizes$8, {
    full: {},
    auto: {}
  }),
  variants: {
    responsive: {
      dialog: /*#__PURE__*/responsiveDialogStyles('responsive'),
      dialogContainer: /*#__PURE__*/responsiveDialogContainerStyles('responsive'),
      closeButton: /*#__PURE__*/responsiveCloseButtonStyles('responsive')
    },
    bottom: {
      dialog: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/responsiveDialogStyles('bottom')), {}, {
        borderTopRadius: 0
      }),
      dialogContainer: /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/responsiveDialogContainerStyles('bottom')),
      closeButton: {
        top: '300',
        right: '300'
      }
    },
    modal: {
      dialog: /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/responsiveDialogStyles('modal')),
      dialogContainer: /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/responsiveDialogContainerStyles('modal')),
      closeButton: {
        top: '300',
        right: '300'
      }
    }
  }
};

var $suggestedValueRadius = /*#__PURE__*/cssVar$1('suggested-value-radius');
var $thumbRadius = /*#__PURE__*/cssVar$1('thumb-radius');
var $trackSize = /*#__PURE__*/cssVar$1('track-size');
var focusOffset = /*#__PURE__*/calc$1.divide($thumbRadius, 4);
var suggestedValueInset = /*#__PURE__*/calc$1.divide($trackSize, 1.4);
var suggestedValueOffset = /*#__PURE__*/calc$1.divide( /*#__PURE__*/calc$1.multiply($suggestedValueRadius, -1), 2);

// NOTE: For some reason, we have to use functions instead of just objects when
// using `cssVar('name').variable` to set these variables, otherwise they don't
// end up getting set in the CSS when rendered for the first time in a very
// specific case that only occurs when deployed in the production build... 🤨
var sizes$2 = {
  small: function small() {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({}, $suggestedValueRadius.variable, sizes$9[100]), $thumbRadius.variable, sizes$9[75]), $trackSize.variable, sizes$9[25])
    };
  },
  medium: function medium() {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({}, $suggestedValueRadius.variable, sizes$9[200]), $thumbRadius.variable, sizes$9[100]), $trackSize.variable, sizes$9[50])
    };
  },
  large: function large() {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({}, $suggestedValueRadius.variable, sizes$9[300]), $thumbRadius.variable, sizes$9[200]), $trackSize.variable, sizes$9[75])
    };
  }
};
var backgroundTransition = /*#__PURE__*/transitions(['background'], motion.easings[150]);
var Slider = {
  defaultProps: {
    size: 'default'
  },
  parts: ['container', 'filledTrack', 'suggestedValueTrack', 'suggestedValue', 'thumb', 'track'],
  baseStyle: function baseStyle(_ref) {
    var orientation = _ref.orientation;
    var suggestedValueTransform = "translate(".concat(suggestedValueOffset, ", ").concat(orientation && orientation === 'vertical' ? '50%' : '-50%', ")");
    return {
      container: {
        _disabled: {
          opacity: 1
        }
      },
      suggestedValueTrack: _objectSpread2(_objectSpread2({
        background: 'neutral.200',
        borderRadius: 900,
        transform: suggestedValueTransform,
        width: $suggestedValueRadius.reference,
        height: $suggestedValueRadius.reference
      }, backgroundTransition), {}, {
        zIndex: 2,
        '&[data-filled]': {
          background: 'primary.500',
          '[aria-disabled] &': {
            background: 'neutral.300'
          }
        },
        '[aria-disabled] &': {
          background: 'neutral.100'
        }
      }),
      suggestedValue: {
        borderRadius: 900,
        transform: suggestedValueTransform,
        width: $suggestedValueRadius.reference,
        height: $suggestedValueRadius.reference,
        zIndex: 4,
        _after: _objectSpread2(_objectSpread2({}, position('absolute', suggestedValueInset)), {}, {
          borderRadius: 900,
          content: '""',
          background: 'neutral.0'
        })
      },
      thumb: _objectSpread2(_objectSpread2({
        background: 'neutral.0',
        borderRadius: 900,
        width: $thumbRadius.reference,
        height: $thumbRadius.reference,
        shadow: 'distance200',
        position: 'relative',
        zIndex: 5
      }, transitions(['box-shadow', 'transform'], motion.easings[250])), {}, {
        _before: _objectSpread2(_objectSpread2({
          borderRadius: 900,
          content: "''",
          shadow: 'invisibleNeutral'
        }, position('absolute', '-1px')), transitions(['box-shadow', 'transform'], motion.easings[250])),
        _after: _objectSpread2(_objectSpread2({
          background: 'primary.200',
          borderRadius: 900,
          content: "''",
          opacity: 0
        }, position('absolute', focusOffset)), transitions(['opacity'], motion.easings[250])),
        _active: {
          shadow: 'distance300',
          _before: {
            shadow: 'invisibleNeutral'
          }
        },
        _focus: {
          shadow: 'distance200',
          _before: {
            shadow: 'haloPrimary'
          },
          '&[data-suggested]:after': {
            opacity: 1
          }
        },
        _disabled: {
          background: 'neutral.50'
        }
      }),
      track: _objectSpread2(_objectSpread2({
        borderRadius: 900,
        background: 'neutral.200',
        zIndex: 1
      }, backgroundTransition), {}, {
        _disabled: {
          background: 'neutral.100'
        }
      }, orient({
        orientation: orientation,
        horizontal: {
          h: $trackSize.reference
        },
        vertical: {
          w: $trackSize.reference
        }
      })),
      filledTrack: _objectSpread2(_objectSpread2({
        background: 'primary.500',
        '[aria-disabled] &': {
          background: 'neutral.300'
        },
        borderRadius: 900,
        zIndex: 3
      }, backgroundTransition), orient({
        orientation: orientation,
        horizontal: {
          h: $trackSize.reference
        },
        vertical: {
          w: $trackSize.reference
        }
      }))
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$2), {}, {
    "default": sizes$2.medium
  }),
  variants: {}
};

var _excluded = ["theme"];
var TRACK_LENGTH = 1;
var $thumbSize = /*#__PURE__*/cssVar$1('thumb-size');
var spaceForBorder = /*#__PURE__*/spaceForBorderWidth(400);
var applySpacing = function applySpacing(spacing) {
  return function (_ref) {
    var flexDirection = _ref.flexDirection;
    return _defineProperty(_defineProperty({}, flexDirection === 'row' ? 'marginStart' : 'marginEnd', spacing), flexDirection === 'row-reverse' ? 'marginStart' : 'marginEnd', 0);
  };
};
var sizes$1 = {
  small: function small(props) {
    return {
      container: _defineProperty({}, $thumbSize.variable, variables.size(100).reference),
      label: _objectSpread2({
        textStyle: 'body400'
      }, applySpacing(100)(props))
    };
  },
  medium: function medium(props) {
    return {
      container: _defineProperty({}, $thumbSize.variable, variables.size(200).reference),
      label: _objectSpread2({
        textStyle: 'body500'
      }, applySpacing(200)(props))
    };
  },
  large: function large(props) {
    return {
      container: _defineProperty({}, $thumbSize.variable, variables.size(300).reference),
      label: _objectSpread2({
        textStyle: 'body600'
      }, applySpacing(200)(props))
    };
  }
};
var Switch = {
  defaultProps: {
    flexDirection: 'row',
    size: 'default'
  },
  parts: ['container', 'control', 'label'],
  baseStyle: function baseStyle(_ref3) {
    var isNext = _ref3.theme.components.isNext,
      props = _objectWithoutProperties(_ref3, _excluded);
    var disabledCheckedColor = isNext ? 'neutral.400' : 'primary.300';
    return {
      container: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      label: _objectSpread2(_objectSpread2({}, label(props)), {}, {
        fontFamily: 'body',
        fontWeight: 'body'
      }),
      thumb: {
        width: $thumbSize.reference,
        height: $thumbSize.reference,
        _checked: {
          transform: "translateX(".concat(TRACK_LENGTH * 100, "%)")
        }
      },
      track: _objectSpread2(_objectSpread2({
        borderRadius: 'round',
        width: calc$1.multiply($thumbSize, 1 + TRACK_LENGTH)
      }, _mergeDeepRight(control(props), {
        _focus: {
          borderColor: 'primary.500'
        },
        _invalid: {
          _focus: {
            borderColor: 'danger.500'
          }
        },
        _disabled: {
          background: 'neutral.300',
          _checked: {
            background: disabledCheckedColor,
            borderColor: disabledCheckedColor
          }
        }
      })), {}, {
        borderWidth: 400,
        borderStyle: 'solid',
        borderColor: 'neutral.400',
        padding: spaceForBorder(100),
        background: 'neutral.400'
      })
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$1), {}, {
    "default": sizes$1.medium
  }),
  variants: {}
};

var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};
var Table = {
  defaultProps: {
    size: 'medium',
    variant: 'default'
  },
  parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'tfoot'],
  baseStyle: {
    table: {
      fontFamily: 'body',
      color: 'neutral.700',
      bgColor: 'neutral.0',
      width: '100%'
    },
    th: /*#__PURE__*/_objectSpread2({
      color: 'neutral.600',
      fontFamily: 'body',
      fontWeight: '400',
      textTransform: 'none',
      letterSpacing: 'normal'
    }, numericStyles),
    td: /*#__PURE__*/_objectSpread2({}, numericStyles),
    tbody: {
      borderTop: '1px',
      borderBottom: '1px',
      borderColor: 'neutral.300'
    },
    tfoot: {
      paddingY: '400',
      paddingX: '200',
      _first: {
        paddingLeft: '400'
      },
      _last: {
        paddingRight: '400'
      }
    }
  },
  sizes: {
    small: {
      table: {
        textStyle: 'body400'
      },
      th: {
        textStyle: 'body400',
        paddingY: '300',
        paddingX: '100',
        _first: {
          paddingLeft: '300'
        },
        _last: {
          paddingRight: '300'
        }
      },
      td: {
        paddingY: '300',
        paddingX: '100',
        _first: {
          paddingLeft: '300'
        },
        _last: {
          paddingRight: '300'
        }
      }
    },
    medium: {
      table: {
        textStyle: 'body500'
      },
      th: {
        textStyle: 'body500',
        paddingY: '400',
        paddingX: '200',
        _first: {
          paddingLeft: '400'
        },
        _last: {
          paddingRight: '400'
        }
      },
      td: {
        paddingY: '400',
        paddingX: '200',
        _first: {
          paddingLeft: '400'
        },
        _last: {
          paddingRight: '400'
        }
      }
    }
  },
  variants: {
    "default": {}
  }
};

var INDICATOR_THICKNESS = '4px';
var spaceForIndicator = function spaceForIndicator(value) {
  return math("".concat(space[value], " - ").concat(INDICATOR_THICKNESS));
};
var spacingFor = function spacingFor(orientation, variant, value) {
  if (variant !== 'primary') return {};
  return {
    '&:not(first-of-type)': orientation === 'vertical' ? {
      marginTop: value
    } : {
      marginLeft: value
    },
    paddingTop: orientation === 'horizontal' ? 0 : INDICATOR_THICKNESS,
    paddingBottom: 0
  };
};
var sizes = {
  small: function small(_ref) {
    var orientation = _ref.orientation,
      variant = _ref.variant;
    return {
      heading: {
        marginLeft: 500,
        paddingRight: 500,
        marginTop: 600,
        minWidth: 500
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 500 : 400,
        paddingTop: orientation === 'vertical' ? 200 : 300,
        paddingBottom: orientation === 'vertical' ? 200 : spaceForIndicator(300),
        textStyle: 'body400'
      }, spacingFor(orientation, variant, 300))
    };
  },
  medium: function medium(_ref2) {
    var orientation = _ref2.orientation,
      variant = _ref2.variant;
    return {
      heading: {
        marginLeft: 600,
        paddingRight: 600,
        marginTop: 600,
        minWidth: 600
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 600 : 500,
        paddingTop: orientation === 'vertical' ? 300 : 400,
        paddingBottom: orientation === 'vertical' ? 300 : spaceForIndicator(400),
        textStyle: 'body500'
      }, spacingFor(orientation, variant, 500))
    };
  },
  large: function large(_ref3) {
    var orientation = _ref3.orientation,
      variant = _ref3.variant;
    return {
      heading: {
        marginLeft: 600,
        paddingRight: 600,
        marginTop: 600,
        minWidth: 700
      },
      tab: _objectSpread2({
        paddingX: orientation === 'vertical' ? 600 : 500,
        paddingTop: orientation === 'vertical' ? 400 : 500,
        paddingBottom: orientation === 'vertical' ? 400 : spaceForIndicator(400),
        textStyle: 'body600'
      }, spacingFor(orientation, variant, 600))
    };
  }
};
var variant = function variant() {
  var isPrimary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (props) {
    var orientation = props.orientation;
    var isVertical = orientation === 'vertical';
    var borderProp = orientation === 'vertical' ? 'borderStartWidth' : 'borderBottomWidth';
    var fullSize = orientation === 'vertical' ? {
      width: '100%'
    } : {
      height: '100%'
    };
    var dimensions = isPrimary ? fullSize : {};
    return {
      tablist: _objectSpread2(_objectSpread2({
        borderColor: 'inherit',
        background: isPrimary ? 'transparent' : 'neutral.100'
      }, dimensions), isVertical ? {
        borderRightColor: 'neutral.200',
        borderRightStyle: 'solid',
        borderRightWidth: 400
      } : {}),
      tab: _objectSpread2(_objectSpread2(_objectSpread2({}, dimensions), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        boxSizing: 'border-box',
        background: 'transparent',
        borderStyle: 'solid',
        borderColor: 'transparent',
        paddingX: isPrimary ? 0 : undefined,
        borderWidth: 0,
        color: isPrimary ? 'neutral.0' : undefined,
        justifyContent: isVertical ? 'start' : 'center',
        textDecorationLine: isPrimary ? 'underline' : 'none',
        textDecorationColor: 'transparent'
      }, borderProp, INDICATOR_THICKNESS), "_focusVisible", isPrimary ? {
        background: 'transparent',
        position: 'relative',
        _before: {
          background: 'primary.500',
          borderBottomRadius: '2px',
          width: '100%',
          height: INDICATOR_THICKNESS,
          content: "''",
          position: 'absolute',
          lineHeight: '0px',
          top: '0'
        }
      } : {
        background: 'neutral.200'
      }), "_active", {}), "_disabled", {
        color: isPrimary ? 'primary.200' : 'neutral.600'
      }), "_hover", isPrimary ? {
        color: 'neutral.0',
        textDecorationColor: 'neutral.0',
        _selected: {
          color: 'neutral.0',
          textDecorationColor: 'transparent'
        }
      } : {
        color: 'primary.500',
        _disabled: {
          color: 'neutral.600'
        }
      }), "_selected", _defineProperty({
        color: isPrimary ? 'neutral.0' : 'primary.base',
        cursor: 'default',
        borderColor: isPrimary ? 'neutral.0' : 'primary.base'
      }, borderProp, INDICATOR_THICKNESS)), transitions(['color', 'border-color', 'text-decoration-color', motion.easings[150]])), resetFocus({
        background: 'neutral.200'
      }, true))
    };
  };
};
var Tabs = {
  defaultProps: {
    size: 'default',
    variant: 'secondary'
  },
  parts: ['heading', 'indicator', 'root', 'tab', 'tablist', 'tabpanel', 'tabpanels'],
  baseStyle: function baseStyle(_ref4) {
    var _ref4$align = _ref4.align,
      align = _ref4$align === void 0 ? 'start' : _ref4$align,
      orientation = _ref4.orientation;
    var alignments = {
      end: 'flex-end',
      center: 'center',
      start: 'flex-start'
    };
    return {
      root: {
        display: orientation === 'vertical' ? 'flex' : 'block'
      },
      heading: {
        borderBottomColor: 'neutral.200',
        borderBottomStyle: 'solid',
        borderBottomWidth: 400,
        textStyle: 'body400',
        fontWeight: 'heading',
        fontFamily: 'heading',
        marginBottom: 0,
        textTransform: 'uppercase'
      },
      tab: _objectSpread2(_objectSpread2(_objectSpread2({}, noFocus), {}, {
        // Egh, the CSS reset applies this because the tabs have `[type=button]`
        appearance: 'none !important',
        fontFamily: 'body',
        color: 'neutral.700',
        cursor: 'pointer'
      }, transitions(['border-color', 'background-color'], motion.easings[250])), {}, {
        _focus: {
          boxShadow: 'none'
        },
        _disabled: {
          cursor: 'default'
        }
      }),
      tablist: {
        justifyContent: alignments[align],
        flexDirection: orientation === 'vertical' ? 'column' : 'row'
      },
      tabpanels: {
        boxSizing: 'border-box'
      },
      tabpanel: {
        padding: 300
      }
    };
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes), {}, {
    "default": sizes.medium
  }),
  variants: {
    primary: /*#__PURE__*/variant(true),
    secondary: /*#__PURE__*/variant(false)
  }
};

var SMALL_CONTENT_SIZE = '16px';
var MEDIUM_CONTENT_SIZE = '20px';
var LARGE_CONTENT_SIZE = sizes$9[200];
var colorFor = function colorFor(colorScheme) {
  switch (colorScheme) {
    case 'primary':
      return {
        bg: 'primary.600',
        color: 'neutral.0'
      };
    case 'dark':
      return {
        bg: 'neutral.600',
        color: 'neutral.0'
      };
    default:
      return {
        bg: 'neutral.100',
        color: 'neutral.700'
      };
  }
};
var Tag = {
  defaultProps: {
    size: 'medium',
    variant: 'solid',
    colorScheme: 'light'
  },
  parts: ['closeButton', 'container', 'icon', 'label'],
  baseStyle: {
    container: {
      borderRadius: '300',
      fontFamily: 'body',
      fontWeight: 'bodySemiBold',
      width: 'fit-content'
    },
    closeButton: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
      opacity: 1,
      margin: '0',
      borderWidth: '0',
      borderRadius: '3px',
      _focus: {
        shadow: 'none'
      },
      padding: 0
    }, /*#__PURE__*/transition.easing150('background', 'color')), {}, {
      _hover: {
        opacity: 1,
        cursor: 'pointer'
      },
      svg: {
        width: '50%',
        height: '50%'
      }
    }),
    icon: {
      boxSizing: 'border-box'
    },
    label: {
      display: 'inline-flex',
      alignItems: 'center'
    }
  },
  sizes: {
    small: {
      container: {
        padding: '1px',
        textStyle: 'body300'
      },
      icon: {
        width: SMALL_CONTENT_SIZE,
        height: SMALL_CONTENT_SIZE,
        padding: '50'
      },
      label: {
        marginX: '100',
        height: SMALL_CONTENT_SIZE,
        textStyle: 'body300'
      },
      closeButton: {
        width: SMALL_CONTENT_SIZE,
        height: SMALL_CONTENT_SIZE
      }
    },
    medium: {
      container: {
        paddingY: '50',
        paddingX: '50',
        textStyle: 'body400'
      },
      icon: {
        width: MEDIUM_CONTENT_SIZE,
        height: MEDIUM_CONTENT_SIZE,
        padding: '50'
      },
      label: {
        marginX: '200',
        height: MEDIUM_CONTENT_SIZE,
        textStyle: 'body400'
      },
      closeButton: {
        width: MEDIUM_CONTENT_SIZE,
        height: MEDIUM_CONTENT_SIZE
      }
    },
    large: {
      container: {
        padding: '100',
        textStyle: 'body500'
      },
      icon: {
        width: LARGE_CONTENT_SIZE,
        height: LARGE_CONTENT_SIZE,
        padding: '100'
      },
      label: {
        marginX: '200',
        height: LARGE_CONTENT_SIZE,
        textStyle: 'body500'
      },
      closeButton: {
        width: LARGE_CONTENT_SIZE,
        height: LARGE_CONTENT_SIZE
      }
    }
  },
  variants: {
    solid: function solid(_ref) {
      var colorScheme = _ref.colorScheme,
        colors = _ref.theme.colors;
      var closeBackground = colors.alpha(colorScheme === 'light' ? 0.9 : 0.75, 'neutral.900');
      return {
        container: _objectSpread2({}, colorFor(colorScheme)),
        closeButton: {
          opacity: 0.7,
          _focus: {
            bg: closeBackground
          },
          _hover: {
            opacity: 0.8,
            bg: closeBackground
          }
        }
      };
    },
    soft: function soft(_ref2) {
      var colorScheme = _ref2.colorScheme,
        colors = _ref2.theme.colors;
      return {
        container: _objectSpread2({}, colors.softColorFor(colorScheme)),
        closeButton: _objectSpread2(_objectSpread2({}, colors.softColorFor(colorScheme)), {}, {
          _hover: _objectSpread2({}, colors.softColorFor(colorScheme, true))
        })
      };
    }
  }
};

var Text = {
  defaultProps: {
    size: 500
  },
  baseStyle: {
    color: 'neutral.text',
    fontFamily: 'body'
  },
  sizes: sizes$b,
  variants: {
    "default": {
      fontWeight: 'body'
    },
    semiBold: {
      fontWeight: 'bodySemiBold'
    },
    bold: {
      fontWeight: 'bodyBold'
    }
  }
};

var Textarea = {
  defaultProps: {
    size: 'default'
  },
  baseStyle: function baseStyle(props) {
    return _objectSpread2({}, field(props));
  },
  sizes: {
    "default": sizes$a["default"].field,
    tiny: sizes$a.tiny.field,
    small: sizes$a.small.field
  },
  variants: {}
};

var stateSelector = function stateSelector(state) {
  return ".chakra-checkbox[data-".concat(state, "] &, .chakra-radio[data-").concat(state, "] &");
};
var TileControl = {
  defaultProps: {
    variant: 'vertical'
  },
  parts: ['label', 'description'],
  baseStyle: function baseStyle(_ref) {
    var isInvalid = _ref.isInvalid;
    return {
      description: _defineProperty({
        color: isInvalid ? 'danger.500' : 'neutral.600'
      }, stateSelector('disabled'), {
        color: 'neutral.400'
      }),
      label: {
        display: 'inline'
      }
    };
  },
  sizes: {},
  variants: {
    vertical: {
      description: {
        gridRowStart: 2,
        gridRowEnd: 3,
        gridColumnStart: 1,
        gridColumnEnd: 3
      },
      label: {
        gridRowStart: 1,
        gridRowEnd: 2,
        gridColumnStart: 1,
        gridColumnEnd: 3
      }
    },
    horizontal: {
      description: {
        gridRowStart: 1,
        gridRowEnd: 2,
        gridColumnStart: 2,
        gridColumnEnd: 3,
        justifySelf: 'end'
      },
      label: {
        gridColumnEnd: 2
      }
    }
  }
};

var bg = function bg(value) {
  return {
    bg: value,
    '--tooltip-bg': "colors.".concat(value)
  };
};

/**
 * FIXME: for some reason the arrows aren't aligned correctly when the tooltip
 * is placed laterally. We should really figure out the root cause of this, but
 * for now this just adjusts the Popper offset, effectively making the arrow
 * slightly smaller and therfore correctly aligned.
 */
var arrowTweaks = /*#__PURE__*/['left', 'left-end', 'left-start', 'right', 'right-end', 'right-start'].reduce(function (acc, placement) {
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "[data-popper-placement=\"".concat(placement, "\"] &"), {
    '--popper-arrow-size': '6px'
  }));
}, {});
var Tooltip = {
  defaultProps: {
    isOpen: false,
    colorScheme: 'dark',
    flip: true
  },
  baseStyle: function baseStyle(props) {
    var isLight = props.colorScheme === 'light';
    return _objectSpread2(_objectSpread2({
      textStyle: 'body300',
      color: isLight ? 'neutral.text' : 'neutral.0',
      fontFamily: 'body',
      fontWeight: 'bodySemiBold',
      borderRadius: '300',
      paddingX: '100',
      paddingY: '50',
      shadow: 'distance200',
      '--popper-arrow-size': '8px'
    }, arrowTweaks), bg(isLight ? 'neutral.200' : 'neutral.700'));
  },
  sizes: {},
  variants: {}
};

/**
 * Combined components object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { components } from '.';
 *
 * ```ts
 * const theme = extendTheme({ components });
 * ```
 */
var components = {
  Alert: Alert,
  AlertDialog: AlertDialog,
  Badge: Badge,
  Breadcrumb: Breadcrumb,
  Button: Button,
  Checkbox: Checkbox,
  CloseButton: CloseButton,
  Code: Code,
  Divider: Divider,
  Drawer: Drawer,
  Editable: Editable,
  Form: Form,
  FormError: FormError,
  FormLabel: FormLabel,
  Heading: Heading,
  Icon: Icon,
  Input: Input,
  Kbd: Kbd,
  Link: Link,
  List: List,
  Menu: Menu,
  Modal: Modal,
  PinInput: PinInput,
  Popover: Popover,
  Progress: Progress,
  Radio: Radio,
  Select: Select,
  Sheet: Sheet,
  Slider: Slider,
  Switch: Switch,
  Table: Table,
  Tabs: Tabs,
  Tag: Tag,
  Text: Text,
  Textarea: Textarea,
  TileControl: TileControl,
  Tooltip: Tooltip,
  // Brand
  BrandButton: Button$1,
  Decoration: Decoration
};

export { mergeSizesToResponsive as a, components as c, mapResponsive as m, reduceResponsive as r };
